export const EVENT_COLOR = "#886147";

export function getCurrentFinancialYearStart(today = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })) {
  const year = Number(today.slice(0, 4));
  return `${Number(today.slice(5, 7)) >= 4 ? year : year - 1}-04-01`;
}

export function eventsForDate(events, date, fromDate) {
  if (!date || (fromDate ? date < fromDate : date <= new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }))) return [];
  return events.filter((event) => event.startDate <= date && date <= event.endDate);
}
